import { pipe } from 'ramda'
import {
  setCategory,
  setEvent,
  setAction,
  setLabel,
  setReceivedLabel,
  dispatchEvent,
} from '@creditas-lab/analytics-events'

const dispatchReviewEvent = pipe(
  setEvent('autoRefi_returningScreen'),
  setCategory('lead_review'),
  dispatchEvent,
)

const dispatchEnableReviewEvent = pipe(
  setReceivedLabel,
  setAction('login_with_review_link'),
  setEvent('autoRefi_returningScreen'),
  setCategory('lead_review'),
  dispatchEvent,
)

const dispatchLogoClickEvent = pipe(
  setAction('click_to_home'),
  dispatchReviewEvent,
)

const dispatchCloseClickEvent = pipe(
  setAction('click_to_close'),
  dispatchReviewEvent,
)

const dispatchSendAccessCodeEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('send_access_code'),
  dispatchReviewEvent,
)

const dispatchErrorOnSendAccessCodeEvent = pipe(
  setReceivedLabel,
  setAction('error_on_send_access_code'),
  dispatchReviewEvent,
)

const dispatchClickToResendAccessCodeEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('click_to_resend_access_code'),
  dispatchReviewEvent,
)

const dispatchClickToLoginEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('click_to_login'),
  dispatchReviewEvent,
)

const dispatchSuccessfulLoginEvent = pipe(
  setLabel('passwordless_sms'),
  setAction('successful_login'),
  dispatchReviewEvent,
)

const dispatchErrorOnLoginEvent = pipe(
  setReceivedLabel,
  setAction('error_on_login|passwordless_sms'),
  dispatchReviewEvent,
)

export {
  dispatchLogoClickEvent,
  dispatchCloseClickEvent,
  dispatchSendAccessCodeEvent,
  dispatchErrorOnSendAccessCodeEvent,
  dispatchClickToResendAccessCodeEvent,
  dispatchClickToLoginEvent,
  dispatchSuccessfulLoginEvent,
  dispatchErrorOnLoginEvent,
  dispatchEnableReviewEvent,
}
